function dateSorter(firstDate, secondDate) {
  let aDate = new Date(firstDate).getTime()
  let bDate = new Date(secondDate).getTime()
  if (isNaN(aDate)) aDate = 0
  if (isNaN(bDate)) bDate = 0
  return aDate - bDate
}

export default dateSorter
